import { organizationsApi } from '@/api/organizationsApi'
import { useRouteContext } from '@/app/layouts/TenantLayout'
import { billingPath } from '@/lib/routeScope'
import { getConsoleUrl, isConsoleDeployment } from '@/utils/deployment'
import { extractErrorMessage } from '@/utils/errorHandler'
import { toast } from 'sonner'

export function useClearDues() {
	const { orgId } = useRouteContext()

	return async () => {
		if (!orgId) {
			toast.error('Missing organization information. Please ensure you are logged in.')
			return
		}

		if (isConsoleDeployment()) {
			const toastId = toast.loading('Generating payment link...')
			try {
				const response = await organizationsApi.regeneratePaymentLink(orgId)

				if (response?.uri) {
					window.open(response.uri, '_blank', 'noopener,noreferrer')
					toast.success('Payment link opened in a new window', { id: toastId })
				} else {
					toast.error('Failed to generate payment link. Please try again.', { id: toastId })
				}
			} catch (error) {
				console.error('Failed to regenerate payment link:', error)
				const errorMessage = extractErrorMessage(error, 'Failed to generate payment link')
				toast.error(`Error: ${errorMessage}. Please try again.`, { id: toastId })
			}
		} else {
			window.open(`${getConsoleUrl()}${billingPath(orgId)}`, '_blank', 'noopener,noreferrer')
		}
	}
}
